export const getPathByOrganizationId = (organizationId: string): string => {
  let paths = location.pathname.split('/');
  if (organizationId) {
    for (let i = 0; i < paths.length; i++) {
      //path-name：エクスペリエンス一覧リニューアル後修正
      if (paths[i] === 'users_b') {
        if (i + 1 < paths.length) {
          paths[i + 1] = organizationId;
        }
      }
    }
  }
  return paths.join('/');
};
